import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentChecklist = ({ documents }) => {
  const getStatusIcon = (status) => {
    const icons = {
      verified: { name: 'CheckCircle', color: 'text-success' },
      pending: { name: 'Clock', color: 'text-warning' },
      rejected: { name: 'XCircle', color: 'text-error' }
    };
    return icons?.[status] || icons?.pending;
  };

  const verifiedCount = documents?.filter(d => d?.status === 'verified')?.length || 0;
  const totalCount = documents?.length || 0;

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Document Checklist</h3>
        <span className="text-sm text-muted-foreground">{verifiedCount}/{totalCount}</span>
      </div>

      <div className="space-y-3">
        {documents?.map((doc) => {
          const statusIcon = getStatusIcon(doc?.status);

          return (
            <div
              key={doc?.id}
              className="flex items-start gap-3 p-3 rounded-lg border border-border hover:bg-muted/30 transition-colors"
            >
              <div className="p-2 rounded-lg bg-muted">
                <Icon name={doc?.icon} size={16} className="text-muted-foreground" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground mb-1">{doc?.name}</p>
                <div className="flex items-center gap-1">
                  <Icon name={statusIcon?.name} size={14} className={statusIcon?.color} />
                  <span className={`text-xs capitalize ${statusIcon?.color}`}>{doc?.status}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Progress */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Verification Progress</span>
          <span className="text-sm font-semibold text-foreground">{Math.round((verifiedCount / totalCount) * 100)}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className="h-2 rounded-full bg-success transition-all"
            style={{ width: `${(verifiedCount / totalCount) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default DocumentChecklist;